<template>
  <div>
    <vuex-breadcrumb></vuex-breadcrumb>
    <b-row>
      <b-col b-col md="4" class="my-1">
        Total {{totalRows}}
      </b-col>
      <b-col b-col md="4" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="table-transition-example"
          pills
          align="fill"
          class="my-1"
          size="sm"
        ></b-pagination>
      </b-col>
      <b-col md="4" class="my-1">
        <b-button variant="outline-primary"
          size="sm" @click="addEntry"
          v-b-tooltip.hover.right title="Add Entry"
        >
          <b-icon-plus-circle-fill> aria-label="Add Entry"></b-icon-plus-circle-fill>
        </b-button>
      </b-col>
    </b-row>
    <b-card bg-variant="light">
      <b-card-group deck>
        <div v-for="(item) in items" :key="item.id" class="col-xs-6 col-sm-6 col-md-6">
          <b-button-group>
            <b-button size="sm"
              variant="primary" 
              class="mb-2"
              v-b-tooltip.hover.top title="Go Update"
              @click="navigateToUpdate(item)"
            >
              <b-icon-triangle aria-label="Update"></b-icon-triangle>
            </b-button>
            <b-button size="sm"
              variant="primary"
              class="mb-2"
              v-b-tooltip.hover.down title="Go View"
              @click="navigateToShow(item)"
            >
              <b-icon-asterisk aria-label="View"></b-icon-asterisk>
            </b-button>
          </b-button-group>
          <poly-integer-reference-card :data_item="item"></poly-integer-reference-card>
        </div>
      </b-card-group>
    </b-card>
    <b-row>
      <b-col b-col md="4" class="my-1">
        Total {{totalRows}}
      </b-col>
      <b-col b-col md="4" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="table-transition-example"
          pills
          align="fill"
          class="my-1"
          size="sm"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {http_v1} from '@/axios'
import VuexBreadcrumb from './VuexBreadcrumb.vue'
import PolyIntegerReferenceCard from './PolyIntegerReferenceCard.vue'
import {
  BIconAsterisk,
  BIconTriangle,
  BIconPlusCircleFill
} from 'bootstrap-vue'

export default {
  components: {
    VuexBreadcrumb,
    BIconAsterisk,
    BIconTriangle,
    BIconPlusCircleFill,
    PolyIntegerReferenceCard
  },
  data () {
    return {
      link: "/" + "poly-integer-references" + "/create",
      totalRows: 0,
      currentPage: 1,
      perPage: 0,
      items: [],
      included: [],
    }
  },
  methods: {
    addEntry() {
      if(this.reroute_name) {
        this.$router.push( {
          name: this.reroute_name,
          params: {
            ams_template: this.ams_template
          }
        })
      }
      else {
        this.$router.push( {
          path: this.link
        })
      }
    },
    callApi () {
      http_v1.get (
        'api/admin/v1/poly_integer_references', {
          params: {
            page: this.currentPage
          }
        }
      ).then(response => {
        if(response.status == 200) {
          this.totalRows = response.headers.total
          this.perPage = response.headers['per-page']
          this.items = response.data.data
          this.included = response.data.included
        }
        else {
          window.console.log(response.status)
        }
      }).catch(error => {
        this.items = []
        this.totalRows = 0
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          window.console.log(message)
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    navigateToShow(data_item) {
      let nav = {
        name: 'PolyIntegerReferenceShowScreen', 
        params: {
          id: data_item.id
        }
      }
      this.$router.push(nav)
    },
    navigateToUpdate(data_item) {
      let nav = {
        name: 'PolyIntegerReferenceUpdateScreen', 
        params: {
          id: data_item.id
        }
      }
      this.$router.push(nav)
    }
  },
  watch: {
    currentPage() {
      this.callApi()
    }
  },
  mounted() {
    this.callApi()
  }
}
</script>
